import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=86d6e336&scoped=true&lang=css"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d6e336"]])

export default __exports__